export default {
  meta: {
    title: '铺位管理'
  }
};
